module.exports = __webpack_public_path__ + "static/media/westkent.e1e14b5d.png";